import React__default from 'react';

var ArticleByline = function ArticleByline(props) {
  var bylineElement = props.bylineElement,
    affiliation = props.affiliation;
  return /*#__PURE__*/React__default.createElement("div", {
    "automation-id": "article-byline",
    className: "font-serif text-p-14 font-bold tracking-[1.3px] md:text-p-16"
  }, bylineElement, affiliation && /*#__PURE__*/React__default.createElement("div", null, affiliation));
};

export { ArticleByline };
//# sourceMappingURL=article-by-line.esm.js.map
